import styled from 'styled-components';

import { StyledTextField } from '../text-fieldish/text-fieldish.styled';

export const StyledTextInput = styled(StyledTextField)``;
